import * as React from 'react';
import {FreightShipMode} from '../../shared/constants';
import {ManifestStatus, OutboundTrailerManifestDetail} from './ManifestInterfaces';

interface ManifestDetailActionButtonsProps {
  manifest: OutboundTrailerManifestDetail;
  disableCompleteAction: boolean;
  disableCancelAction: boolean;
  onCancel: () => void;
  onComplete: () => void;
  onManifestComplete: () => void;
}

function ManifestDetailActionButtons(props: ManifestDetailActionButtonsProps) {
  const renderFreightButtons = () => {
    return (
      <div className="col-sm-6">
        <button
          disabled={props.disableCancelAction}
          className="btn btn-primary pull-right"
          data-testid="freight-cancel-btn"
          onClick={() => props.onCancel()}
        >
          Cancel Trailer
        </button>
        <button
          disabled={props.disableCompleteAction}
          className="btn btn-primary pull-right"
          data-testid="freight-ship-btn"
          onClick={props.onManifestComplete}
        >
          Ship
        </button>
      </div>
    );
  };

  const renderParcelButtons = () => {
    return (
      <div className="col-sm-6">
        <button
          disabled={props.disableCancelAction}
          className="btn btn-primary pull-right"
          data-testid="parcel-cancel-btn"
          onClick={() => props.onCancel()}
        >
          Cancel Trailer
        </button>
        <button
          disabled={props.disableCompleteAction}
          className="btn btn-primary pull-right"
          data-testid="parcel-ship-btn"
          onClick={() => props.onComplete()}
        >
          {'Submit and Close Trailer'}
        </button>
      </div>
    );
  };

  const render = () => {
    if (props.manifest && props.manifest.status === ManifestStatus.open) {
      if (props.manifest.shipMode === FreightShipMode) {
        return renderFreightButtons();
      } else {
        return renderParcelButtons();
      }
    } else {
      return <div></div>;
    }
  };

  return render();
}

export default ManifestDetailActionButtons;
